import { FiBell, FiDollarSign, FiPlay } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";
import { useWindowSize } from "./useWindowSize";
import { useState } from "react";
import "./VerticalAccordion.css";

const VerticalAccordion = ({ items = defaultItems, className = "" }) => {
    const [open, setOpen] = useState(items[0].id);

    return (
        <section className={`accordion-section ${className}`}>
            <div className="accordion-container">
                {items.map((item) => {
                    return (
                        <Panel
                            key={item.id}
                            open={open}
                            setOpen={setOpen}
                            id={item.id}
                            Icon={item.Icon}
                            title={item.title}
                            imgSrc={item.imgSrc}
                            description={item.description}
                            buttonText={item.buttonText}
                        />
                    );
                })}
            </div>
        </section>
    );
};

const Panel = ({ open, setOpen, id, Icon, title, imgSrc, description, buttonText }) => {
    const { width } = useWindowSize();
    const isOpen = open === id;

    // Check if Icon is a string (image URL) or a component
    const isImageIcon = typeof Icon === 'string';

    return (
        <>
            <button
                className="panel-btn"
                onClick={() => setOpen(id)}
            >
                <span className="vertical-text">
                    {title}
                </span>
                <span className="horizontal-text">{title}</span>
                <div className="icon-container">
                    {isImageIcon ? <img src={Icon} alt="" className="w-full h-full object-contain p-1" /> : <Icon />}
                </div>
                <span className="active-indicator" />
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        key={`panel-${id}`}
                        variants={width && width > 1024 ? panelVariants : panelVariantsSm}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        style={{
                            backgroundImage: `url(${imgSrc})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                        }}
                        className="panel-content"
                    >
                        <motion.div
                            variants={descriptionVariants}
                            initial="closed"
                            animate="open"
                            exit="closed"
                            className="panel-description"
                        >
                            <h3 className="panel-heading">{title}</h3>
                            <p>{description}</p>
                            {buttonText && <button className="panel-cta-btn">{buttonText}</button>}
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default VerticalAccordion;

const panelVariants = {
    open: {
        width: "100%",
        height: "100%",
    },
    closed: {
        width: "0%",
        height: "100%",
    },
};

const panelVariantsSm = {
    open: {
        width: "100%",
        height: "380px",
    },
    closed: {
        width: "100%",
        height: "0px",
    },
};

const descriptionVariants = {
    open: {
        opacity: 1,
        y: "0%",
        transition: {
            delay: 0.125,
        },
    },
    closed: { opacity: 0, y: "-100%" },
};

const defaultItems = [
    {
        id: 1,
        title: "Earn more",
        Icon: FiDollarSign,
        imgSrc:
            "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
        description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
    },
    {
        id: 2,
        title: "Play more",
        Icon: FiPlay,
        imgSrc:
            "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80",
        description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
    },
    {
        id: 3,
        title: "Keep track",
        Icon: FiBell,
        imgSrc:
            "https://images.unsplash.com/photo-1578450671530-5b6a7c9f32a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
        description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
    },
];
